import { render, staticRenderFns } from "./reading.vue?vue&type=template&id=499d90c7&scoped=true&"
import script from "./reading.vue?vue&type=script&lang=js&"
export * from "./reading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d90c7",
  null
  
)

export default component.exports